import { render } from "./complaintsSuggestions.vue?vue&type=template&id=8bcd68bc&scoped=true"
import script from "./complaintsSuggestions.vue?vue&type=script&lang=js"
export * from "./complaintsSuggestions.vue?vue&type=script&lang=js"

import "./complaintsSuggestions.vue?vue&type=style&index=0&id=8bcd68bc&scoped=true&lang=css"
import "./complaintsSuggestions.vue?vue&type=style&index=1&id=8bcd68bc&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcd68bc"]])

export default __exports__